import PaddedMaxWidthContainer from 'components/layout/PaddedMaxWidthContainer';
import TrendingPrizeCard from '../TrendingPrizeCard';
import SectionHeading from '../SectionHeading';
import { ASSET_PREFIX } from 'utils/constants';
import PrizeList from '../PrizeList';
import PrizeCardWithTitleBelow from '../PrizeCardWithTitleBelow';
import LoadingSpinner from 'components/LoadingSpinner';
import { GroupedPrizes, Prize } from 'types/Prize';

interface IRedemptionFlow {
	prizes: GroupedPrizes | null;
	setSelectedPrize: React.Dispatch<React.SetStateAction<Prize>>;
}

export const RedemptionFlow = ({
	prizes,
	setSelectedPrize,
}: IRedemptionFlow) => {
	if (!prizes) {
		return <LoadingSpinner loadingText={undefined} style={undefined} />;
	}
	return (
		<>
			{/* TRENDING PRIZES SECTION */}
			{Object.keys(prizes).length > 0 && (
				<PaddedMaxWidthContainer
					style={{
						margin: '5px 0 0 0',
						width: '100%',
						maxWidth: '100%',
						background: '#F6F6F6',
					}}
				>
					{/* HERO PRIZE */}
					{prizes['HERO'].length > 0 && (
						<div className="trendingPrizesContainer">
							<TrendingPrizeCard
								prize={prizes['HERO'][0]} // only one hero card
								isHeroCard
								onClick={() => setSelectedPrize(prizes['HERO'][0])}
							/>
						</div>
					)}

					{/* SMALLER TRENDING GRID PRIZES */}
					{prizes['TRENDING_GRID'].length > 0 && (
						<div className="trendingPrizesGrid">
							{prizes['TRENDING_GRID'].map((trendingGridPrize: any) => (
								<TrendingPrizeCard
									key={trendingGridPrize.slug}
									prize={trendingGridPrize}
									onClick={() => setSelectedPrize(trendingGridPrize)}
									isHeroCard={undefined}
								/>
							))}
						</div>
					)}
				</PaddedMaxWidthContainer>
			)}

			{/* BEST OF REST SECTION */}
			{prizes['BEST_OF_REST']?.length > 0 && (
				<PaddedMaxWidthContainer
					style={{ margin: 0, width: '100%', maxWidth: '100%' }}
				>
					{(prizes['HERO'].length > 0 ||
						prizes['TRENDING_GRID'].length > 0) && ( // Only show "Best Of The Rest" heading if the Trending Prizes section above is shown
						<SectionHeading
							iconSrc={`${ASSET_PREFIX}/images/prizes/magnifying-glass.svg`}
							title="Browse All"
							style={{
								padding: '3em 1em',
								background: 'white',
							}}
							subheading={undefined}
						/>
					)}

					<PrizeList
						pageSize={6}
						style={{
							maxWidth: 1100,
						}}
					>
						{prizes['BEST_OF_REST']?.length > 0 &&
							prizes['BEST_OF_REST'].map((prize: any) => (
								<PrizeCardWithTitleBelow
									key={prize.slug}
									prize={prize}
									onClick={() => setSelectedPrize(prize)}
									showPrizeTierBadge={false}
									withFavouriteButton={true}
									showLockedPrizeBannerIfApplicable={false}
								/>
							))}
					</PrizeList>
				</PaddedMaxWidthContainer>
			)}
		</>
	);
};
